module.exports = __webpack_public_path__ + "img/confirmacao.b2e24305.png";